import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300;400;700;900&display=swap');

  *, *::before, *::after {
    box-sizing: border-box;
    font-family: 'Noto Sans KR', sans-serif;
  }
 
  button{
background: inherit ; border:none; box-shadow:none; border-radius:0; padding:0; overflow:visible; cursor:pointer}
  body { 
      
      margin: 0;
      padding: 0;
      background-color:  rgb(37 18 26);
  }

  #root {
    display: flex;
      flex-flow: row wrap;
      justify-content: center;
     width: 100%;
   } 
`;

export default GlobalStyle;
